export const ABRIR_EJERCICIO = "ABRIR_EJERCICIO";
export const CERRAR_EJERCICIO = "CERRAR_EJERCICIO";
export const RESIZE = "RESIZE";
export const MUEVE_TRANSDUCTOR = "MUEVE_TRANSDUCTOR";
export const MUEVE_SLIDER = "MUEVE_SLIDER";
export const ADD_RECORRIDOS = "ADD_RECORRIDOS";
export const RESETEA_RECORRIDO = "RESET_RECORRIDO";
export const SET_MODO_TRANSDUCTOR = "SET_MODO_TRANSDUCTOR";
export const ACTUALIZA_CARGADO = "ACTUALIZA_CARGADO";
export const LOGIN_USER = "LOGIN_USER";
export const UPDATE_USER_DATA = "UPDATE_USER_DATA";
export const NAVEGA = "NAVEGA";
export const CARGA_ABORDAJE = "CARGA_ABORDAJE";
export const SITUAR_IMAGEN = "SITUAR_IMAGEN";
export const TERMINA_RECORRIDO = "TERMINA_RECORRIDO";
export const ABRIR_VIDEO = "ABRIR_VIDEO";
export const CERRAR_VIDEO = "CERRAR_VIDEO";
